<div class="supplier-pl">
    <vsf-breadcrumbs *ngIf="isPreOrder; else supplierBreadcrumbs" [items]="[{ label: 'Home', link: '/' }, { label: 'Pre-Order Opportunities', link: '/pricelists/pre-order' }, { label: 'Pricelist #' + (supplierInfo?.id || '') }]"></vsf-breadcrumbs>
    <ng-template #supplierBreadcrumbs><vsf-breadcrumbs [items]="[{ label: 'Home', link: '/' }, { label: 'Pricelist #' + (supplierInfo?.id || '') }]"></vsf-breadcrumbs></ng-template>

    <div class="supplier-pl__card">
        <div class="supplier-pl__head">
            <div class="supplier-pl__title-row">
                <h1 class="supplier-pl__title">
                    <ng-container *ngIf="supplierInfo?.code">{{ supplierInfo?.code }} · </ng-container>Pricelist #{{ supplierInfo?.id }}
                </h1>
                <span *ngIf="isPreOrder" class="supplier-pl__badge supplier-pl__badge--preorder">Pre-Order</span>
            </div>
            <vsf-export-download-menu
                label="Download Pricelist"
                buttonClass="supplier-pl__download"
                iconSrc="assets/icons/download-icon.svg"
                [showShareLink]="true"
                ariaLabel="Download supplier pricelist"
                (download)="downloadSupplierProductsEvent.emit($event)"
                (shareLink)="shareSupplierLinkEvent.emit($event)"
            ></vsf-export-download-menu>
        </div>

        <div class="supplier-pl__terms">
            <span class="supplier-pl__term">
                <span class="supplier-pl__term-label">MOV</span>
                <span class="supplier-pl__term-value">{{ supplierInfo?.mov | formatPrice }}</span>
                <img
                    src="assets/icons/info-circle-outline.svg"
                    alt=""
                    class="supplier-pl__term-info"
                    title="Minimum order value for this pricelist"
                />
            </span>
            <span class="supplier-pl__term-sep" *ngIf="deliveryTerm" aria-hidden="true">·</span>
            <span class="supplier-pl__term" *ngIf="deliveryTerm">
                <span class="supplier-pl__term-label">ETA</span>
                <span class="supplier-pl__term-value">{{ deliveryTerm }}</span>
            </span>
            <span class="supplier-pl__term-sep" *ngIf="showPrePayment" aria-hidden="true">·</span>
            <span class="supplier-pl__term" *ngIf="showPrePayment">
                <span class="supplier-pl__term-label">Pre-payment</span>
                <span class="supplier-pl__term-value">{{ supplierInfo?.prePaymentPercentage }}%</span>
            </span>
        </div>

        <div class="supplier-pl__progress-row">
            <div class="supplier-pl__progress">
                <div class="supplier-pl__progress-fill" [style.width.%]="progressPercentage"></div>
            </div>
            <div class="supplier-pl__progress-meta">
                <span>Amount {{ supplierSpecificTotal | formatPrice }}</span>
                <span class="supplier-pl__progress-sep" aria-hidden="true">·</span>
                <span *ngIf="progressPercentage < 100">
                    {{ remainingCents | formatPrice }} remaining
                </span>
                <span *ngIf="progressPercentage >= 100" class="supplier-pl__ready">Ready for checkout</span>
                <span *ngIf="appliedVolumeDiscountPercent" class="supplier-pl__discount-applied">
                    · Volume discount {{ appliedVolumeDiscountPercent }}% applied
                </span>
            </div>
        </div>

        <div class="supplier-pl__tiers" *ngIf="tierChips.length">
            <button
                type="button"
                class="supplier-pl__tier"
                *ngFor="let chip of tierChips"
                [class.supplier-pl__tier--active]="chip.active"
                [attr.aria-pressed]="chip.active"
                (click)="selectTier(chip)"
            >
                {{ chip.label }}
            </button>
        </div>
    </div>
</div>
